import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getStoredSettings } from 'src/utils/settings';
import tenantsService from 'src/services/tenantService';
import useSettings from 'src/hooks/useSettings';
import configService from 'src/services/configService';
import g7Service from 'src/submodules/commons-auth/G7/G7Service';
function AuthGuard({ children }) {
  const account = useSelector((state) => state.account);
  const { settings, saveSettings } = useSettings();
  const storedSettings = getStoredSettings();
  const currentTenant = tenantsService.getCurrentTenant();
  const isG7View = g7Service.isG7();
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token');
  
  if(!isG7View || token){
    if (!account.user) {
      return <Redirect to="/auth" />;
    }
  }


  if(currentTenant && !storedSettings) {
    let p = settings;

    if(currentTenant?.properties?.props?.thema)
      p.theme = currentTenant?.properties?.props?.thema;
    
    saveSettings(p);
  }

  return children;
}

AuthGuard.propTypes = {
  children: PropTypes.any
};

export default AuthGuard;
